var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28056_18920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.23588 7.26404C7.61193 7.87424 8.12562 8.38793 8.73582 8.76399L9.31148 8.41858C9.43407 8.34503 9.57623 8.31075 9.71887 8.32034C9.86151 8.32994 9.9978 8.38295 10.1094 8.47225L11.2267 9.36608C11.3041 9.42793 11.3674 9.50547 11.4125 9.59359C11.4577 9.68171 11.4837 9.7784 11.4887 9.87728C11.4938 9.97617 11.4778 10.075 11.4419 10.1673C11.4059 10.2595 11.3509 10.3431 11.2803 10.4126L10.7752 10.9092C10.4373 11.2424 9.99654 11.4514 9.52473 11.5023C9.05291 11.5533 8.57775 11.443 8.17654 11.1896C6.82913 10.3181 5.68182 9.17074 4.81032 7.82333C4.55686 7.42212 4.44661 6.94695 4.49752 6.47513C4.54843 6.0033 4.7575 5.56259 5.09071 5.22468L5.58733 4.71958C5.65675 4.64897 5.74034 4.59389 5.8326 4.55796C5.92487 4.52203 6.0237 4.50606 6.12258 4.51112C6.22146 4.51618 6.31815 4.54214 6.40626 4.5873C6.49438 4.63246 6.57192 4.69578 6.63377 4.7731L7.52761 5.8904C7.61691 6.00204 7.66992 6.13832 7.67952 6.28096C7.68911 6.4236 7.65483 6.56576 7.58128 6.68834L7.23588 7.26404Z",
    stroke: "#D53E20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3923 13.6065L2.50319 13.9222C2.44512 13.9319 2.38559 13.9276 2.32953 13.9096C2.27347 13.8917 2.2225 13.8606 2.18088 13.819C2.13926 13.7774 2.10818 13.7264 2.09022 13.6703C2.07227 13.6143 2.06796 13.5547 2.07766 13.4967L2.39328 11.6075C1.50316 10.224 1.15596 8.56038 1.41844 6.93642C1.68092 5.31246 2.53456 3.84289 3.81518 2.81034C5.09579 1.77779 6.71295 1.25518 8.35564 1.34301C9.99833 1.43085 11.5505 2.12293 12.7137 3.28615C13.877 4.44938 14.569 6.0016 14.6568 7.64429C14.7446 9.28698 14.222 10.9041 13.1894 12.1847C12.1569 13.4653 10.6873 14.319 9.06332 14.5814C7.43936 14.8439 5.7757 14.4966 4.3923 13.6065Z",
    stroke: "#D53E20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28056_18920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappOrange);
export default __webpack_public_path__ + "static/media/whatsapp-orange.eca5fe4f2c99d8280223df10f9047cbc.svg";
export { ForwardRef as ReactComponent };